import React, { useState } from "react";
import {
  // DateRangeDelimiter,
  DateRangePicker as MuiDateRangePicker
} from "@material-ui/pickers";
import clsx from "clsx";
import {
  FormGroup,
  InputBase,
  Typography,
  makeStyles
} from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import { useTranslation } from "@/langs/useTranslation";

const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    padding: `1px ${theme.spacing(1)}px`,
    borderRadius: 4,
    marginRight: theme.spacing(2),

    "&:hover": {
      borderColor: "#333"
    }
  },
  focus: {
    transition: "all .2s",
    borderColor: `${theme.palette.primary.main} !important`,
    boxShadow: `0 0 0 1px ${theme.palette.primary.main} inset`
  },
  clearable: {
    paddingRight: 24
  },
  delimiter: {
    margin: `0 ${theme.spacing(2)}px 0 ${theme.spacing(1)}px`,
    display: "flex",
    alignItems: "center"
  },
  close: {
    position: "absolute",
    fontSize: 18,
    right: 6,
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.palette.text.secondary,
    cursor: "pointer",
    zIndex: 10,

    "&:hover": {
      color: theme.palette.text.main
    }
  }
}));

const DateRangePicker = ({
  name,
  value = [null, null],
  onChange,
  startPlaceholder,
  endPlaceholder,
  clearable = true
}) => {
  const classes = useStyles();
  const { t, userLanguage } = useTranslation();
  const [focus, setFocus] = useState(false);

  const handleDateChange = date => {
    if (date && date[1]) {
      date[1] = date[1].endOf("d");
    }
    onChange?.({ target: { name, value: date } });
  };

  const renderDateRangeInput = (startProps, endProps) => {
    return (
      <FormGroup
        row
        tabIndex={0}
        className={clsx(
          classes.root,
          focus && classes.focus,
          clearable && classes.clearable
        )}
        onFocus={() => {
          setFocus(true);
        }}
        onBlur={() => {
          setFocus(false);
        }}
      >
        <InputBase
          ref={startProps.ref}
          {...startProps.inputProps}
          placeholder={startPlaceholder || t({ defaultMessage: "开始时间" })}
        />
        <Typography
          component="div"
          color="textSecondary"
          className={classes.delimiter}
        >
          -
        </Typography>
        <InputBase
          ref={endProps.ref}
          {...endProps.inputProps}
          placeholder={endPlaceholder || t({ defaultMessage: "结束时间" })}
        />
        {clearable && value[0] && value[1] && (
          <CloseOutlined
            fontSize="small"
            color="inherit"
            className={classes.close}
            onClick={() => onChange({ target: { name, value: [null, null] } })}
          />
        )}
      </FormGroup>
    );
  };

  const handleDateRangeError = (reason /* , value */) => {
    reason.forEach(element => {
      console.error(element);
    });
  };

  return (
    <MuiDateRangePicker
      inputFormat={userLanguage === "zh_cn" ? "YYYY年MM月DD日" : "YYYY/MM/DD"}
      calendars={2}
      showToolbar={false}
      value={value}
      onChange={handleDateChange}
      onError={handleDateRangeError}
      renderInput={renderDateRangeInput}
    />
  );
};

export default DateRangePicker;
